<template>
  <div class="h-100">
   
        <component v-bind:is="layout"/>
    
  </div>
</template>

<script>
import AppLayout from './layouts/AppLayout'
import BaseLayout from './layouts/BaseLayout'
import DashboardLayout from './layouts/DashboardLayout'

export default {
  computed: {
    layout () {
      return this.$store.getters['app/layout']
    }
  },
  components: {
    'app-layout': AppLayout,
    'base-layout': BaseLayout,
    'dashboard-layout': DashboardLayout
  },
   mounted() {
    // check for active theme
    let htmlElement = document.documentElement;
    let theme = localStorage.getItem("theme");

    if (theme === "dark") {
      htmlElement.setAttribute("theme", "dark");
      this.darkMode = true;
    } else {
      htmlElement.setAttribute("theme", "light");
      this.darkMode = false;
    }
  }
}
</script>
